import "./index.scss";
import React from "react";
import LogoImg from "../../../assets/logo.png";

function LoginLayout({ title, children }) {
  return (
    <div id="LoginLayout" className="LoginLayout">
      <div className="form-side col-md-12 col-sm-12">
        <section className="content-section">
          <div className="logo-container"></div>
          <div className="form-content p-5">
            <div className="title-container">
              <div className="login-header text-center">
                <img src={LogoImg} alt="Logo" height="60" />
                <br />
                <h2 class="p-3">{title}</h2>
              </div>
            </div>

            {children}
          </div>
        </section>
      </div>
      {/* <div className="image-side d-none d-md-flex col-md-6">
        <div className="text-overlay">
          <h2>Votre espace de gestion, à portée de clic.</h2>
          <div className="text-container">
            <p>Gérez Les Utilisateurs</p>
            <p>Suivez Les Formations</p>
            <p>Analysez Les Performances</p>
          </div>
          <div className="emoji">🤝</div>
        </div>
      </div> */}
    </div>
  );
}

export default LoginLayout;
